export default __webpack_public_path__ + "static/media/sprkl_v2.cb74d840.jpg";